<template>
  <div class="first-entry">
    <div class="first-entry-wrap">
      <div class="carousel">
        <div class="carousel-control">
          <div class="prev-text"
               @click="prevCarousel">
            <div class="carousel-text" :style="carouselTextStyle">
              <div class="text" :class="{ active: carouselIndex === 0 }"></div>
              <div class="text" :class="{ active: carouselIndex === 1 }"
                   v-html="$t('dashboard.firstEntry.pane1.name')"></div>
              <div class="text" :class="{ active: carouselIndex === 2 }"
                   v-html="$t('dashboard.firstEntry.pane2.name')"></div>
              <div class="text" :class="{ active: carouselIndex === 3 }"
                   v-html="$t('dashboard.firstEntry.pane3.name')"></div>
            </div>
          </div>

          <div class="next-text"
               @click="nextCarousel">
            <div class="carousel-text" :style="carouselTextStyle">
              <div class="text" :class="{ active: carouselIndex === 0 }"
                   v-html="$t('dashboard.firstEntry.pane2.name')"></div>
              <div class="text" :class="{ active: carouselIndex === 1 }"
                   v-html="$t('dashboard.firstEntry.pane3.name')"></div>
              <div class="text" :class="{ active: carouselIndex === 2 }"
                   v-html="$t('dashboard.firstEntry.pane4.name')"></div>
              <div class="text" :class="{ active: carouselIndex === 3 }"></div>
            </div>
          </div>

          <button class="prev"
                  :class="{ disabled: carouselIndex <= 0 }"
                  @click="prevCarousel">
            <i class="icon icon--arrow-left-gray"></i>
          </button>
          <button class="next"
                  :class="{ disabled: carouselIndex >= 3 }"
                  @click="nextCarousel">
            <i class="icon icon--arrow-right-gray"></i>
          </button>

          <div class="carousel-navigation">
            <button v-for="idx in [0, 1, 2, 3]"
                    :key="`carousel${idx}`"
                    :class="{ active: idx === carouselIndex }"
                    @click="setCarouselIndex(idx)"></button>
          </div>
        </div>

        <div class="carousel-body">
          <div class="carousel-board" :style="carouselBodyStyle">
            <div class="carousel-content">
              <div class="c c1" :class="$i18n.locale">
                <div class="title">
                  <h2 v-html="$t('dashboard.firstEntry.pane1.title')"></h2>
                  <p v-html="$t('dashboard.firstEntry.pane1.description')"></p>
                </div>
              </div>
            </div>
            <div class="carousel-content">
              <div class="c c2">
                <div class="image"></div>
                <div class="text">
                  <h3 v-html="$t('dashboard.firstEntry.pane2.title')"></h3>
                  <p v-html="$t('dashboard.firstEntry.pane2.description')"></p>
                </div>
              </div>
            </div>
            <div class="carousel-content">
              <div class="c c3">
                <div class="image"></div>
                <div class="text">
                  <h3 v-html="$t('dashboard.firstEntry.pane3.title')"></h3>
                  <p v-html="$t('dashboard.firstEntry.pane3.description')"></p>
                </div>
              </div>
            </div>
            <div class="carousel-content">
              <div class="c c4">
                <div class="image"></div>
                <div class="text">
                  <h3 v-html="$t('dashboard.firstEntry.pane4.title')"></h3>
                  <p v-html="$t('dashboard.firstEntry.pane4.description')"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-footer">
          <div class="button--area">
            <p class="description" v-html="$t('dashboard.firstEntry.footer.description')"></p>
            <div class="buttons">
              <ui-button :primary="true"
                         :iconName="'icon--plus-white'"
                         @click="go({ name: 'add' })">{{ $t('dashboard.firstEntry.footer.registerDomain') }}</ui-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'FirstEntry',
  components: {
    UiButton
  },
  computed: {
    carouselBodyStyle () {
      return { transform: `translateX(${-800 * this.carouselIndex}px)` }
    },
    carouselTextStyle () {
      return { transform: `translateX(${-100 * this.carouselIndex}px)` }
    }
  },
  methods: {
    go (params) {
      EventBus.$emit('onLoading', true)
      setTimeout(() => {
        this.$router.push(params)
      }, 300)
    },
    setCarouselIndex (idx) {
      this.carouselIndex = idx
    },
    prevCarousel () {
      if (this.carouselIndex > 0) {
        this.carouselIndex--
      }
    },
    nextCarousel () {
      if (this.carouselIndex < 3) {
        this.carouselIndex++
      }
    }
  },
  data () {
    return {
      carouselIndex: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.first-entry {
  .first-entry-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 450px;
    border-radius: 40px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background: linear-gradient(332deg, #3d3589 27%, #101046 81%);

    .carousel {
      position: relative;

      .carousel-control {
        .prev-text,
        .next-text {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 4;
          width: 100px;
          white-space: nowrap;
          cursor: pointer;

          .carousel-text {
            transition: transform 0.5s ease;
          }

          .text {
            display: inline-block;
            vertical-align: middle;
            width: 100px;
            font-size: 12px;
            line-height: 1.58;
            color: #767676;
            transition: opacity 0.15s ease;
            opacity: 0;

            &.active {
              opacity: 1;
            }
          }
        }

        .prev-text {
          left: -173px;
          text-align: right;
        }

        .next-text {
          right: -173px;
          text-align: left;
        }

        .prev,
        .next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          transition: opacity 0.2s ease;
          z-index: 5;
          width: 38px;
          height: 38px;
          padding: 11px;
          border-radius: 20px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;

          &.disabled {
            opacity: 0;
            cursor: default;
            pointer-events: none;
          }
        }

        .prev {
          left: -58px;
        }

        .next {
          right: -58px;
        }

        .download {
          position: absolute;
          top: 30px;
          right: 20px;
          color: #ffffff;
          font-size: 13px;
          z-index: 5;

          .icon {
            margin-right: 5px;
            vertical-align: middle;
          }

          .text {
            vertical-align: middle;
          }
        }

        .carousel-navigation {
          position: absolute;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 5;

          button {
            width: 8px;
            height: 8px;
            background-color: #666666;
            overflow: hidden;
            margin: 0 4px;
            border-radius: 4px;
            transition: background-color 0.2s ease;

            &.active {
              background-color: #ffffff;
            }
          }
        }
      }

      .carousel-body {
        white-space: nowrap;
        overflow: hidden;

        .carousel-board {
          transition: transform 0.5s ease;
        }

        .carousel-content {
          display: inline-block;
          width: 800px;
          height: 450px;
          position: relative;
          vertical-align: top;

          .c {
            height: 100%;

            .image {
              display: inline-block;
              vertical-align: top;
              width: 326px;
              height: 205px;
              margin: 100px 60px 0 80px;
            }

            .text {
              display: inline-block;
              vertical-align: top;
              margin-top: 110px;

              h3 {
                font-size: 22px;
                font-weight: 500;
                color: #ffffff;

                & /deep/ span {
                  display: block;
                  margin-bottom: 8px;
                  font-size: 16px;
                }
              }

              p {
                margin-top: 30px;
                font-size: 14px;
                line-height: 1.57;
                color: #ffffff;
              }
            }

            &.c1 {
              background: url(../../assets/img/dashboard/background-character.svg) no-repeat 333px 199px;

              .title {
                padding: 83px 0 0 30px;

                h2 {
                  font-size: 50px;
                  line-height: 1;
                  color: #ffffff;
                  font-weight: normal;

                  & /deep/ span {
                    color: #ec0147;
                  }
                }

                p {
                  margin: 13px 0 0 0;
                  font-size: 16px;
                  line-height: 1.56;
                  color: #aaaaaa;
                }
              }
            }

            &.c2 {
              .image {
                background: url(../../assets/img/dashboard/first-entry-1.svg);
                background-size: 100% 100%;
              }
            }

            &.c3 {
              .image {
                background: url(../../assets/img/dashboard/first-entry-2.svg);
                background-size: 100% 100%;
              }
            }

            &.c4 {
              .image {
                background: url(../../assets/img/dashboard/first-entry-3.svg);
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }

    .button--area {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 92px;
      background: #ffffff;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;

      .description {
        position: absolute;
        top: 50%;
        left: 34px;
        transform: translateY(-50%);
        color: #aaaaaa;
        font-size: 13px;
      }

      .buttons {
        position: absolute;
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
